/**
 * Upsell Components
 * Handles the "Make It Extra Special" upsell drawer functionality
 */

(function() {
  'use strict';

  /**
   * Close nested detail drawer after successful add to cart
   * Listens for variant:add events on forms with data-close-on-add attribute
   */
  function initCloseOnAdd() {
    document.addEventListener('variant:add', function(event) {
      const form = event.target;

      // Check if this form should close its parent drawer
      if (form && form.hasAttribute('data-close-on-add')) {
        const drawer = form.closest('x-drawer[data-upsell-detail]');

        if (drawer && typeof drawer.hide === 'function') {
          // Small delay to allow user to see success state
          setTimeout(function() {
            drawer.hide();
          }, 300);
        }
      }
    }, true);
  }

  /**
   * Add visual feedback when item is added to cart
   */
  function initAddFeedback() {
    document.addEventListener('variant:add', function(event) {
      const form = event.target;

      if (!form) return;

      // Find the parent product card
      const card = form.closest('.upsell-product-card');

      if (card) {
        // Add success state
        card.classList.add('is-added');

        // Find the button and update text briefly
        const button = form.querySelector('button[type="submit"]');
        if (button) {
          const originalText = button.innerHTML;
          button.innerHTML = '<span>Added!</span>';

          setTimeout(function() {
            button.innerHTML = originalText;
            card.classList.remove('is-added');
          }, 2000);
        }
      }
    }, true);
  }

  /**
   * Handle loading state on add buttons
   */
  function initLoadingState() {
    document.addEventListener('submit', function(event) {
      const form = event.target;

      if (!form.classList.contains('upsell-add-form') &&
          !form.classList.contains('upsell-detail-add-form')) {
        return;
      }

      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.classList.add('is-loading');
      }
    }, true);

    // Remove loading state after cart change
    document.addEventListener('cart:change', function() {
      const loadingButtons = document.querySelectorAll('.upsell-product-card__add-btn.is-loading');
      loadingButtons.forEach(function(button) {
        button.classList.remove('is-loading');
      });
    });
  }

  /**
   * Accessibility: Return focus to trigger button when drawer closes
   */
  function initFocusManagement() {
    // Store the last trigger element
    let lastTrigger = null;

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[aria-controls^="upsell-"]');
      if (trigger) {
        lastTrigger = trigger;
      }
    });

    // When drawer closes, return focus to trigger
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const drawer = mutation.target;
          if (!drawer.hasAttribute('open') && lastTrigger) {
            // Drawer just closed, return focus
            lastTrigger.focus();
            lastTrigger = null;
          }
        }
      });
    });

    // Observe all upsell drawers for open attribute changes
    document.querySelectorAll('x-drawer[id^="upsell-"]').forEach(function(drawer) {
      observer.observe(drawer, { attributes: true });
    });
  }

  /**
   * Initialize all upsell components
   */
  function init() {
    initCloseOnAdd();
    initAddFeedback();
    initLoadingState();

    // Initialize focus management after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFocusManagement);
    } else {
      initFocusManagement();
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
